import { APP_SET_TOKEN,
  APP_SET_GROUP,
  APP_SET_SEASON,
  APP_SET_ORDER_FILTERS,
  APP_SET_ORDER_HIDDEN_COLUMNS,
  APP_SET_ORDER_SEARCH_FIELDS,
  APP_SET_ORDER,
  APP_UPDATE_ORDER,
  APP_DELETE_ORDER,
  APP_SET_MODULE,
  APP_ALLOW_AUTO_ORDER_UPDATE,
  APP_SET_EMPLOYEE_ID,
  APP_SET_EMPLOYEE_CONFIG_ID,
  APP_SET_ORDER_COLUMNS_WIDTH,
  APP_SET_ORDER_COLUMNS_SEQUENCE,
  APP_SET_USER_EMAIL,
  REACT_APP_VERSION } from './redux-actions';
import { orderColumns } from './column-definitions';

export const appReducer = (
  state = {
    token: null,
    group: null,
    season: '',
    order: {},
    module: '',
    allowAutoOrderUpdate: true,
    employeeId: null,
    employeeConfigId: null,
    version: process.env.REACT_APP_VERSION
  },
  action
) => {
  switch (action.type) {
  case REACT_APP_VERSION:
    return {
      ...state,
      version: action.payload
    };
  case APP_SET_TOKEN:
    return {
      ...state,
      token: action.payload
    };
  case APP_SET_GROUP:
    return {
      ...state,
      group: action.payload
    };
  case APP_SET_SEASON:
    return {
      ...state,
      season: action.payload
    };
  case APP_SET_ORDER:
    return {
      ...state,
      order: action.payload
    };
  case APP_UPDATE_ORDER:
    return {
      ...state,
      order: action.payload
    };
  case APP_DELETE_ORDER:
    return {
      ...state,
      order: {}
    };
  case APP_SET_MODULE:
    return {
      ...state,
      module: action.payload
    };
  case APP_ALLOW_AUTO_ORDER_UPDATE:
    return {
      ...state,
      allowAutoOrderUpdate: action.payload
    };
  case APP_SET_EMPLOYEE_ID:
    return {
      ...state,
      employeeId: action.payload
    };
  case APP_SET_EMPLOYEE_CONFIG_ID:
    return {
      ...state,
      employeeConfigId: action.payload
    };
  case APP_SET_USER_EMAIL:
    return {
      ...state,
      userEmail: action.payload
    };
  default:
    return state;
  }
};

export const employeeOrderConfigReducer = (
  state = {
    orderColumnsWidth: [],
    orderFilters: [],
    orderHiddenColumns: [],
    orderSearchFields: orderColumns().slice(1)
      .map(obj => obj.field),
    orderColumnsSequence: orderColumns().slice(1)
      .map(obj => obj.field)
  },
  action
) => {
  switch (action.type) {
  case APP_SET_ORDER_COLUMNS_WIDTH:
    return {
      ...state,
      orderColumnsWidth: {
        ...state.orderColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_ORDER_FILTERS:
    return {
      ...state,
      orderFilters: {
        ...state.orderFilters,
        ...action.payload
      }
    };
  case APP_SET_ORDER_HIDDEN_COLUMNS:
    return {
      ...state,
      orderHiddenColumns: action.payload
    };
  case APP_SET_ORDER_SEARCH_FIELDS:
    return {
      ...state,
      orderSearchFields: action.payload
    };
  case APP_SET_ORDER_COLUMNS_SEQUENCE:
    return {
      ...state,
      orderColumnsSequence: action.payload
    };
  default:
    return state;
  }
};
